import { render, staticRenderFns } from "./PayRangeVersionManageDrawer.vue?vue&type=template&id=33e65064&scoped=true"
import script from "./PayRangeVersionManageDrawer.vue?vue&type=script&setup=true&lang=js"
export * from "./PayRangeVersionManageDrawer.vue?vue&type=script&setup=true&lang=js"
import style0 from "./PayRangeVersionManageDrawer.vue?vue&type=style&index=0&id=33e65064&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e65064",
  null
  
)

export default component.exports